import t from"./getBoundingClientRect.js";function e(e){var h=t(e),f=e.offsetWidth,i=e.offsetHeight;return Math.abs(h.width-f)<=1&&(f=h.width),Math.abs(h.height-i)<=1&&(i=h.height),{x:e.offsetLeft,y:e.offsetTop,width:f,height:i}}export{e as default};
//# sourceMappingURL=getLayoutRect.js.map
